<footer class="footer">
  <div class="logoRyndem">
    <img alt="logoRyndem" id="logoRyndem" src="assets/Images/ryndem.svg" />
  </div>
</footer>
